import { array, boolean, object, string } from 'yup';
const DeclarationSchema = object().shape({
  intendToOccupy: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  anotherPropertyOwnershipInterest: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option').when('intendToOccupy', {
    is: value => !value,
    then: schema => schema.notRequired()
  }),
  typePropertyOwned: string().required('Please select type').when('anotherPropertyOwnershipInterest', {
    is: d1 => !d1,
    then: schema => schema.notRequired()
  }),
  titleHoldType: string().required('Please select type').when('anotherPropertyOwnershipInterest', {
    is: d1 => !d1,
    then: schema => schema.notRequired()
  }),
  downPaymentBorrowed: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  amountOfMoneyBorrower: string().when('downPaymentBorrowed', {
    is: downPaymentBorrowed => downPaymentBorrowed,
    then: schema => schema.required('Please provide amount')
  }),
  anotherPropertyBeforeClosing: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  undisclosedNewCredit: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  lienSubjectProperty: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  undisclosedPropertyMortgageLoan: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  outstandingJudgements: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  defaultOnFederalDebt: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  partyToLawsuit: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  propertyTitleForeclosure: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  preForeclosureSale: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  propertyForeclosed: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  declaredBankruptcy: boolean().nullable().required('Please select an option').oneOf([true, false], 'Please select an option'),
  bankruptcyDeclarationTypeList: array().of(string()).when('declaredBankruptcy', {
    is: q15 => q15,
    then: schema => schema.required('Please select bankruptcy type').test({
      message: 'Please select bankruptcy type',
      test: arr => (arr === null || arr === void 0 ? void 0 : arr.length) !== 0
    })
  })
});
export default DeclarationSchema;
//# sourceMappingURL=index.js.map